import axios from 'axios';
import useJwt from '@/auth/jwt/useJwt';

const costDimensions = `${process.env.VUE_APP_URL}/api/v1/dimensions/`;
const costDimension = `${process.env.VUE_APP_URL}/api/v1/dimension/`;
export default {
  namespaced: true,
  state: {
    dimensionsList: [],
    dimensionDrivers: [],
    dimensionDataSample: [],
    totalRecords: null,
    nextUrl: null,
    previousUrl: null,
    currentUrl: null,
    recordData: { identifier: "", driverData:{} },
    editDimensionData: {
      id:null,
      pid:null,
      title:null,
    }
  },
  mutations: {
    SET_DIMENSION_DATA(state, data){
      state.editDimensionData = data
    },
    SET_DIMENSION_TITLE(state, data){
      state.editDimensionData.title = data
    },
    SET_DIMENSION_PID(state, data){
      state.editDimensionData.pid = data
    },

    SET_DIMENSIONS(state, dimensions) {
      if(!dimensions) {
        return;
      }
      if(dimensions instanceof String){
        state.dimensionsList = JSON.parse(dimensions)
      }else{
        state.dimensionsList = dimensions
      }
    },

    SET_DIMENSIONS_STATE(state, dimensions) {
      if(!dimensions) {
        return;
      }
      state.dimensionsList = dimensions
    },
    SET_DIMENSION_DRIVERS(state, drivers) {
      if(!drivers){
        return;
      }
      state.dimensionDrivers = drivers
    },
    SET_DIMENSION_DATA_SAMPLE(state, dataSample) {
      state.dimensionDataSample = dataSample
    },
    SET_NEXT_URL(state, url) {
      state.nextUrl = url
    },
    SET_PREVIOUS_URL(state, url) {
      state.previousUrl = url
    },
    SET_CURRENT_URL(state, url) {
      state.currentUrl = url
    },
    SET_TOTAL_RECORDS(state, records) {
      state.totalRecords = records
    },
    SET_NEW_DATA_FIELD(state, { id, driverId }) {
      state.recordData.driverData[driverId].id = id;
      state.recordData.driverData[driverId].valueExists = true;
    },
    CLEAR_RECORD_DATA(state) {
      state.recordData = { identifier: "" }
      state.recordData.driverData = {}
      state.dimensionDrivers.forEach((dri) => {
        state.recordData.driverData[dri.id] = {
          id: dri.id,
          value: null,
        };
      });
    },
    SET_RECORD_DATA(state, data) {
      state.recordData = data
    },
    SET_RECORD_IDENTIFIER(state, data) {
      state.recordData.identifier = data
    }
  },
  actions: {
    createUpdateRecordEdit({ state }, { context, modelId, mode }) {
      if (mode == "UPDATE") {
        return context.$http.patch(`${costDimension}records/${state.recordData.id}/`, { ...state.recordData });
      }
      //return context.$http.post(calculatedDrivers, { ...state.calculatedDriverForm });
    },
    getDimensions({ commit }, { context, modelId }) {
      if(!modelId){
        return;
      }
      return context.$http.get(`${costDimensions}get-dimensions-page-data/?model=${modelId}`)
        .then(response => {
          commit('SET_DIMENSIONS', response.data);
        });
    },
    deleteDimension({ state }, { context, dimensionId }) {
      return context.$http.delete(
        `${costDimensions}${dimensionId}/`);
    },
    getDimensionDrivers({ commit }, { context, dimensionId }) {
      if (!dimensionId) {
        return;
      }
      context.$http.get(
        `${costDimension}drivers/?dimension=${dimensionId}`,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${useJwt.getToken()}`
          }
        })
        .then(response => {
          commit('SET_DIMENSION_DRIVERS', response.data);
        });
    },
    getDimensionDataSample({ commit, state }, { context, scenarioId, dimensionId, endpoint, limit }) {
      let getData = state.currentUrl || `${costDimension}records/?scenario=${scenarioId}&dimension=${dimensionId}&limit=${limit}&offset=0`;
      context.$http.get(
        getData,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${useJwt.getToken()}`
          }
        })
        .then(response => {
          commit('SET_DIMENSION_DATA_SAMPLE', response.data.results);
          commit('SET_NEXT_URL', response.data.next);
          commit('SET_PREVIOUS_URL', response.data.previous);
          commit('SET_TOTAL_RECORDS', response.data.count);
        });
    },
    setNextUrlAsCurrent({ commit, state }) {
      commit('SET_CURRENT_URL', state.nextUrl);
    },
    setPreviousUrlAsCurrent({ commit, state }) {
      commit('SET_CURRENT_URL', state.PreviousUrl);
    },
    clearDimensionDrivers({ commit }) {
      commit('SET_DIMENSION_DRIVERS', []);
    },
    clearDimensionDataSample({ commit }) {
      commit('SET_DIMENSION_DATA_SAMPLE', [])
    }
  },
}
